import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from "@angular/core";

@Component({
  selector:"app-chips",
  templateUrl:"./chips.directive.html",
  styleUrls:["./chips.directive.scss"],
  encapsulation:ViewEncapsulation.None // Use to disable CSS Encapsulation for this component
})

export class ChipsComponent implements OnChanges {

  @Input() chipName: any;
  @Input() chipValues: any;
  @Output() clearChip: EventEmitter<any> = new EventEmitter<any>();

  chip: any = {};
  chipDisplay: string = "none";
  titleMSG: string = "";

  constructor() {

  }

  clearVal(event) {
    this.clearChip.emit(event);
    event.stopPropagation();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.chipName) {
      this.chip.name = changes.chipName.currentValue || changes.chipName.previousValue;
      this.titleMSG = `Clear ${this.chip.name}`;
    }
    if (changes.chipValues) {
      this.chip.value = changes.chipValues.currentValue || changes.chipValues.previousValue;
      this.chip.value = this.chip.value.join(", ");

    }
    this.chip.display = (this.chip.value.length === 0) ? "none" : "inline-block";
  }
}
